import useSWR, { mutate } from "swr";
import { useEffect, useMemo } from "react";

// Project-imports
import { fetcher } from "utils/axios";

// types
import { MenuProps, NavItemType } from "types/menu";
import useAuth from "hooks/useAuth";

const initialState: MenuProps = {
  isDashboardDrawerOpened: false,
  isComponentDrawerOpened: true,
};

export const endpoints = {
  key: "api/account",
  master: "master",
  dashboard: "/menu", // server URL
};

export function useGetMenu() {
  const { isLoggedIn } = useAuth();

  const { data, isLoading, error, isValidating } = useSWR(
    isLoggedIn ? endpoints.key + endpoints.dashboard : null,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  useEffect(() => {
    if (!isLoggedIn) {
      mutate(endpoints.key + endpoints.dashboard, undefined, { revalidate: false });
    }
  }, [isLoggedIn]);

  const memoizedValue = useMemo(
    () => ({
      menu: data?.dashboard as NavItemType,
      libraries: data?.libraries ?? ([] as { id: string | number; name: string; libraryCode?: string; themeColor?: string; fontFamily?: string }[]),
      selectedLibrary: data?.selectedLibrary as string | number | undefined,
      menuLoading: isLoading,
      menuError: error,
      menuValidating: isValidating,
      menuEmpty: !isLoading && !data?.dashboard,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function revalidateMenu() {
  return mutate(endpoints.key + endpoints.dashboard);
}

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(
    endpoints.key + endpoints.master,
    () => initialState,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data as MenuProps,
      menuMasterLoading: isLoading,
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerComponentDrawer(isComponentDrawerOpened: boolean) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: any) => {
      return { ...currentMenuMaster, isComponentDrawerOpened };
    },
    false
  );
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: any) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
